import { createActivityApi } from './src/activity/activity.api';
import { createAuditApi } from './src/audit/audit.api';
import { createAuthApi, createQrLoginApi } from './src/auth/auth.api';
import { createCatalogueApi } from './src/catalogue/catalogue.api';
import { createConversationsApi } from './src/conversations/conversations.api';
import { createFamiliesApi } from './src/families/families.api';
import { createFriendshipsApi } from './src/friendships/friendships.api';
import { createGameNightsApi } from './src/game-nights/game-nights.api';
import { createGamesApi } from './src/games/games.api';
import { type HttpClient } from './src/http';
import { createModerationApi } from './src/moderation/moderation.api';
import { createReportsApi } from './src/reports/reports.api';
import { createNotificationsApi } from './src/notifications/notifications.api';
import { createPresenceApi } from './src/presence/presence.api';
import { createRecommendationsApi } from './src/recommendations/recommendations.api';
import { createSessionsApi } from './src/sessions/sessions.api';
import { createFarewellApi } from './src/farewell/farewell.api';
import { createSupportApi } from './src/support/support.api';
import { createTaxonomiesApi } from './src/taxonomies/taxonomies.api';
import { createUsersApi } from './src/users/users.api';
import { createWishlistsApi } from './src/wishlists/wishlists.api';

export type { HttpClient, MultipartBody } from './src/http';

export * from './src/activity/activity.types';
export * from './src/audit/audit.types';
export * from './src/taxonomies/taxonomies.types';
export * from './src/moderation/moderation.types';
export * from './src/reports/reports.types';
export * from './src/catalogue/catalogue.types';
export * from './src/auth/auth.types';
export * from './src/conversations/conversations.types';
export * from './src/families/families.types';
export * from './src/friendships/friendships.types';
export * from './src/game-nights/game-nights.types';
export * from './src/games/games.types';
export * from './src/notifications/notifications.types';
export * from './src/presence/presence.types';
export * from './src/recommendations/recommendations.types';
export * from './src/sessions/sessions.types';
export * from './src/farewell/farewell.types';
export * from './src/support/support.types';
export * from './src/users/users.types';
export * from './src/wishlists/wishlists.types';

export { createActivityApi } from './src/activity/activity.api';
export { createAuthApi, createQrLoginApi } from './src/auth/auth.api';
export { createConversationsApi } from './src/conversations/conversations.api';
export { createFamiliesApi } from './src/families/families.api';
export { createFriendshipsApi } from './src/friendships/friendships.api';
export { createGameNightsApi } from './src/game-nights/game-nights.api';
export { createGamesApi } from './src/games/games.api';
export { createNotificationsApi } from './src/notifications/notifications.api';
export { createPresenceApi } from './src/presence/presence.api';
export { createRecommendationsApi } from './src/recommendations/recommendations.api';
export { createSessionsApi } from './src/sessions/sessions.api';
export { createSupportApi } from './src/support/support.api';
export { createUsersApi } from './src/users/users.api';
export { createWishlistsApi } from './src/wishlists/wishlists.api';
export type { ActivityApi } from './src/activity/activity.api';
export type { AuthApi, QrLoginApi } from './src/auth/auth.api';
export type { ConversationsApi } from './src/conversations/conversations.api';
export type { FamiliesApi } from './src/families/families.api';
export type { FriendshipsApi } from './src/friendships/friendships.api';
export type { GameNightsApi } from './src/game-nights/game-nights.api';
export type { GamesApi } from './src/games/games.api';
export type { NotificationsApi } from './src/notifications/notifications.api';
export type { PresenceApi } from './src/presence/presence.api';
export type { RecommendationsApi } from './src/recommendations/recommendations.api';
export type { SessionsApi } from './src/sessions/sessions.api';
export type { SupportApi } from './src/support/support.api';
export type { UsersApi } from './src/users/users.api';
export type { WishlistsApi } from './src/wishlists/wishlists.api';

/**
 * Assembles every extracted domain around a single transport.
 *
 * Every domain the screens read is extracted now.
 *
 * @see docs/features/api-client.md
 */
export function createApiClient(http: HttpClient) {
  return {
    activity: createActivityApi(http),
    audit: createAuditApi(http),
    catalogue: createCatalogueApi(http),
    moderation: createModerationApi(http),
    reports: createReportsApi(http),
    taxonomies: createTaxonomiesApi(http),
    conversations: createConversationsApi(http),
    auth: createAuthApi(http),
    qrLogin: createQrLoginApi(http),
    families: createFamiliesApi(http),
    friendships: createFriendshipsApi(http),
    games: createGamesApi(http),
    gameNights: createGameNightsApi(http),
    notifications: createNotificationsApi(http),
    presence: createPresenceApi(http),
    recommendations: createRecommendationsApi(http),
    sessions: createSessionsApi(http),
    support: createSupportApi(http),
    farewell: createFarewellApi(http),
    users: createUsersApi(http),
    wishlists: createWishlistsApi(http),
  };
}

export type ApiClient = ReturnType<typeof createApiClient>;
